module.exports = __webpack_public_path__ + "img/recomendations.5e6983fd.jpg";